import React from 'react';

const LoadingScreen = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      fontFamily: 'Roboto, sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        animation: 'fadeInUp 0.8s ease forwards'
      }}>
        <div style={{ marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: 300,
            color: '#ffffff',
            margin: '0 0 1rem',
            letterSpacing: '0.2em',
            textShadow: '0 0 20px rgba(0, 0, 0, 0.8)'
          }}>
            Rêver
          </h1>
          <div style={{
            fontSize: '1.2rem',
            color: 'rgb(248, 207, 71)',
            fontWeight: 300,
            letterSpacing: '0.1em',
            textShadow: '0 0 10px rgba(248, 207, 71, 0.3)'
          }}>
            Construyendo el futuro
          </div>
        </div>
        
        <div style={{
          position: 'relative',
          width: '80px',
          height: '80px',
          margin: '0 auto'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '80px',
            height: '80px',
            border: '2px solid transparent',
            borderTop: '2px solid rgb(248, 207, 71)',
            borderRadius: '50%',
            animation: 'spin 2s linear infinite'
          }}></div>
          <div style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            width: '60px',
            height: '60px',
            border: '2px solid transparent',
            borderRight: '2px solid rgba(248, 207, 71, 0.6)',
            borderRadius: '50%',
            animation: 'spin 1.5s linear infinite reverse'
          }}></div>
        </div>
      </div>
      
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;